import type { Block } from '@pageboss/shared';
import { InspectorSection } from './inspector-section';
import { InspectorField } from './inspector-field';
import { Repeater, RepeaterTitle } from './repeater';

type FaqBlock = Extract<Block, { type: 'faq' }>;
type FaqProps = FaqBlock['props'];
type Item = FaqProps['items'][number];

function newQuestion(): Item {
  return {
    question: 'New question?',
    answer: 'Type the answer here.',
  };
}

interface FaqInspectorProps {
  block: FaqBlock;
  onChange: (next: FaqProps) => void;
}

export function FaqInspector({ block, onChange }: FaqInspectorProps) {
  const props = block.props;
  const patch = (next: Partial<FaqProps>) => onChange({ ...props, ...next });

  return (
    <>
      <InspectorSection label="Questions">
        <Repeater
          items={props.items}
          onChange={(items) => patch({ items: items as FaqProps['items'] })}
          addLabel="Add question"
          makeNew={newQuestion}
          renderTitle={(item) => <RepeaterTitle>{item.question}</RepeaterTitle>}
          renderForm={(item, _i, update) => (
            <>
              <InspectorField
                label="Question"
                value={item.question}
                placeholder="Do you offer free quotes?"
                onChange={(v) => update({ question: v })}
              />
              <InspectorField
                label="Answer"
                value={item.answer}
                multiline
                rows={4}
                placeholder="Yes — every estimate is free and there's no obligation."
                onChange={(v) => update({ answer: v })}
              />
            </>
          )}
        />
      </InspectorSection>
    </>
  );
}
